import React from "react"
import ButtonGroup from "@yumgmbh/gatsby-theme-yum-components/src/components/molecules/ButtonGroup"
import BlockWrapper from "@yumgmbh/gatsby-theme-yum-components/src/components/technical/BlockWrapper"
import Richtext from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Richtext"
import HeadlineEnhanced from "@yumgmbh/gatsby-theme-yum-components/src/components/molecules/HeadlineEnhanced"

const IntroTextBlock = ({ block }) => {
  return (
    <BlockWrapper
      block={block}
      blockWidth="content"
      showHeadline="false"
      className="bg-gray-100"
    >
      <div className="text-center">
        <HeadlineEnhanced
          kicker={block.kicker}
          headline={block.headline}
          subheadline={block.subheadline}
          headlineLevel="h4"
        />
        <Richtext className="mt-8 text-gray-500" text={block.text} />
        <ButtonGroup className="mt-8" buttons={block.buttons} />
      </div>
    </BlockWrapper>
  )
}

export default IntroTextBlock
